import React, { useState, useRef, useEffect } from 'react';

interface InfoTooltipProps {
  label: React.ReactNode;
  children: React.ReactNode; // содержимое всплывающей подсказки
  className?: string;
  triggerClassName?: string;
}

/**
 * Текст с пунктирным подчёркиванием. На десктопе подсказка показывается при
 * наведении (CSS group-hover — надёжно), на мобильных — по клику (состояние open).
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({ label, children, className, triggerClassName }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <span ref={ref} className={`group relative inline-block ${className || ''}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`underline decoration-dotted decoration-1 underline-offset-4 cursor-help focus:outline-none ${triggerClassName || ''}`}
      >
        {label}
      </button>
      <span
        role="tooltip"
        className={`${open ? 'block' : 'hidden'} group-hover:block absolute z-50 left-0 top-full mt-2 w-72 sm:w-80 rounded-xl bg-white text-gray-700 text-sm leading-relaxed p-4 shadow-2xl ring-1 ring-black/5 text-left normal-case font-normal`}
      >
        {children}
      </span>
    </span>
  );
};

export default InfoTooltip;
